import React , {useMemo, useState } from "react"
import { Outlet, useLocation} from "react-router-dom"
import { Box } from "@mui/material"
import SideBarLayout from "src/v2/layout/side-bar-layout" 
import FluxoTabs from "./componentes/fluxo-tabs"
import FormHeader from "../components/FormHeader"
import {ReactComponent as WarningIcon} from "src/v2/assets/icons/warning-error-icon.svg"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"

export const FluxoLayout = () => {
    const location = useLocation()

    const [caracteristicaState] = useState(() => location.state || {})

    const headerConfig = useMemo(() => {
        if (caracteristicaState.ID) {
            return {
                title: `CETIP ${caracteristicaState.CETIP} . VER ${caracteristicaState.VersaoDocumento}`,
                statusLabel: "CADASTRO EM PRODUÇÃO",
                statusColor: "white",
                statusIcon: <CheckIcon />,
                showDownload: false
            }
        }

        return {
            title: caracteristicaState.CETIP 
                ? `CETIP ${caracteristicaState.CETIP} . VER ${caracteristicaState.VersaoDocumento || '-'}` 
                : "Novo Fluxo", 
            statusLabel: "CADASTRO EM ANDAMENTO",
            statusColor: "warning", 
            statusIcon: <WarningIcon />,
            showDownload: false
        }
    }, [caracteristicaState])
    

    const pageTitle = "Fluxo de Evento"

    return (
        <SideBarLayout
            title={pageTitle}
            header={true}
            headerTitle=""
            headerImage={"/background/eventos_headers.jpg"} 
            headerPosition={"1% 41%"}
        >
            <Box
                sx={{
                    marginTop: -14.5, 
                    paddingBottom: 5,
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    px: { xxxs: 3, md: 3, lg: 0 },
                }}
            >
                <Box mb={4}>
                    <FormHeader
                    title={headerConfig.title}
                    statusLabel={headerConfig.statusLabel}
                    statusColor={headerConfig.statusColor}
                    statusIcon={headerConfig.statusIcon}
                />
                </Box>
                
            </Box>
            <Box sx={{ mt: -9, position: 'relative', zIndex: 2 }}>
                <FluxoTabs />
            </Box>
            <Box >
                <Outlet context={{ caracteristicaState }} />
            </Box>

        </SideBarLayout>
    )
}

export default FluxoLayout
